import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { motion } from 'framer-motion';

const products = [
  { title: "Common Beans", desc: "Red speckled, NUA 45 and white haricot varieties from our research partnerships.", img: "/images/beans.jpg", tag: "Semi-Processed" },
  { title: "Raw Peanut Kernels", desc: "Chalimbana, CG9, CG10 and other premium varieties sourced from our partner farms.", img: "/images/peanut 2.png", tag: "Semi-Processed" },
  { title: "Roasted & Blanched Nuts", desc: "Premium quality roasted peanuts for local and export markets with superior taste.", img: "/images/nut.png", tag: "Value Added" },
  { title: "Peanut Butter", desc: "High-quality peanut butter produced in our modern processing facilities.", img: "/images/AFRI OILS.jpg", tag: "Value Added" },
  { title: "Cooking Oil", desc: "Pure vegetable oil from our oil processing operations across Southern Africa.", img: "/images/raw.jpg", tag: "Value Added" },
  { title: "Maize Products", desc: "Quality maize meal and flour from our commercial farming operations.", img: "/images/ground.jpg", tag: "Value Added" },
];

export function Products() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.8,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.6 }
    }
  };

  return (
    <section className="py-16 bg-gradient-to-r from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="text-center mb-12"
        >
          <h2 className="text-3xl font-bold text-gray-900 mb-8">OUR PRODUCT OFFERING</h2>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="space-y-12"
        >
          {/* Semi-processed Products */}
          <div>
            <motion.div
              variants={itemVariants}
              className="text-center mb-8"
            >
              <div className="inline-flex items-center bg-gradient-to-r from-green-500 to-green-600 px-6 py-3 rounded-full shadow-lg">
                <i className="fas fa-seedling text-white text-xl mr-3"></i>
                <h3 className="text-2xl font-bold text-white">Semi-processed Products</h3>
              </div>
            </motion.div>

            <div className="grid md:grid-cols-2 gap-8">
              <motion.div variants={itemVariants} className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
                <div className="text-center mb-4">
                  <img
                    src="/images/beans.jpg"
                    alt="Common Beans"
                    className="w-full h-32 object-cover rounded-xl mb-4"
                  />
                </div>
                <div className="flex items-center justify-center mb-4">
                  <div className="bg-green-500 text-white p-3 rounded-full mr-3">
                    <i className="fas fa-bean text-xl"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">Common Beans</h4>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                  <div className="bg-green-100 p-3 rounded-lg text-center">
                    <p className="text-green-700 font-semibold">Red speckled</p>
                  </div>
                  <div className="bg-green-200 p-3 rounded-lg text-center">
                    <p className="text-green-700 font-semibold">NUA 45</p>
                  </div>
                  <div className="bg-green-300 p-3 rounded-lg text-center">
                    <p className="text-green-700 font-semibold">White haricot</p>
                  </div>
                </div>
              </motion.div>

              <motion.div variants={itemVariants} className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
                <div className="text-center mb-4">
                  <img
                    src="/images/raw.jpg"
                    alt="Raw Peanut Kernels"
                    className="w-full h-32 object-cover rounded-xl mb-4"
                  />
                </div>
                <div className="flex items-center justify-center mb-4">
                  <div className="bg-amber-600 text-white p-3 rounded-full mr-3">
                    <i className="fas fa-peanut-hot text-xl"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">Raw Peanut Kernels</h4>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                  <div className="bg-amber-100 p-3 rounded-lg text-center">
                    <p className="text-amber-700 font-semibold">Chalimbana</p>
                  </div>
                  <div className="bg-amber-200 p-3 rounded-lg text-center">
                    <p className="text-amber-700 font-semibold">CG9</p>
                  </div>
                  <div className="bg-amber-300 p-3 rounded-lg text-center">
                    <p className="text-amber-700 font-semibold">CG10</p>
                  </div>
                  <div className="bg-amber-400 p-3 rounded-lg text-center">
                    <p className="text-amber-700 font-semibold">Others</p>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>

          {/* Value Added Products */}
          <div>
            <motion.div
              variants={itemVariants}
              className="text-center mb-8"
            >
              <div className="inline-flex items-center bg-gradient-to-r from-amber-600 to-orange-600 px-6 py-3 rounded-full shadow-lg">
                <i className="fas fa-cube text-white text-xl mr-3"></i>
                <h3 className="text-2xl font-bold text-white">Value Added Products</h3>
              </div>
            </motion.div>

            <div className="grid md:grid-cols-2 gap-8">
              <motion.div variants={itemVariants} className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
                <div className="text-center mb-4">
                  <img
                    src="/images/ground 2.jpg"
                    alt="Roasted & Blanched Nuts"
                    className="w-full h-32 object-cover rounded-xl mb-4"
                  />
                </div>
                <div className="flex items-center justify-center mb-4">
                  <div className="bg-orange-600 text-white p-3 rounded-full mr-3">
                    <i className="fas fa-fire text-xl"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">Roasted & Blanched Nuts</h4>
                </div>
                <div className="bg-orange-50 p-4 rounded-lg">
                  <p className="text-orange-700 text-center">Premium quality roasted peanuts for local and export markets with superior taste.</p>
                </div>
              </motion.div>

              <motion.div variants={itemVariants} className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
                <div className="text-center mb-4">
                  <img
                    src="/images/nice.jpg"
                    alt="Peanut Butter"
                    className="w-full h-32 object-cover rounded-xl mb-4"
                  />
                </div>
                <div className="flex items-center justify-center mb-4">
                  <div className="bg-yellow-600 text-white p-3 rounded-full mr-3">
                    <i className="fas fa-jar text-xl"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">Peanut Butter</h4>
                </div>
                <div className="bg-yellow-50 p-4 rounded-lg">
                  <p className="text-yellow-700 text-center">High-quality peanut butter produced in our modern processing facilities.</p>
                </div>
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
